module.exports = __webpack_public_path__ + "static/media/5-6.9e1b676a.png";